import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { authApi } from '../services/api';
import '../styles/pages.css';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ login: '', senha: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authApi.login(credentials);

      if (response.success) {
        const role = localStorage.getItem('admin_role');
        navigate(role === 'viewer' ? '/admin/social' : '/admin');
      } else {
        setError(response.message || 'Usuário ou senha inválidos');
      }
    } catch (err: any) {
      setError(err.message || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container" style={{ background: 'var(--color-gray-light)', paddingTop: '5rem', paddingBottom: '5rem' }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={4}>
            <Card>
              <Card.Body className="p-5">
                <div className="text-center mb-4">
                  <img
                    src="/img/logo-agricampanha.png"
                    alt="Agricampanha"
                    style={{ maxHeight: '60px' }}
                    className="mb-3"
                  />
                  <h2>Admin Login</h2>
                  <p className="text-muted">Sistema de Gestão de Notícias</p>
                </div>

                {error && (
                  <Alert variant="danger" dismissible onClose={() => setError('')}>
                    {error}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="username">
                    <Form.Label>Usuário</Form.Label>
                    <Form.Control
                      type="text"
                      value={credentials.login}
                      onChange={(e) =>
                        setCredentials({ ...credentials, login: e.target.value })
                      }
                      required
                      placeholder="Digite seu usuário"
                      disabled={loading}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="password">
                    <Form.Label>Senha</Form.Label>
                    <Form.Control
                      type="password"
                      value={credentials.senha}
                      onChange={(e) =>
                        setCredentials({ ...credentials, senha: e.target.value })
                      }
                      required
                      placeholder="Digite sua senha"
                      disabled={loading}
                    />
                  </Form.Group>

                  <Button variant="primary" type="submit" className="w-100" size="lg" disabled={loading}>
                    {loading ? 'Entrando...' : 'Entrar'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminLogin;
